import {useMapContext} from '@/components/MindMap/index.mjs'
import MenuButton from '../../MenuButton.jsx'

export default function MenuButtonPushProduct(props) {
    const map = useMapContext()
    const canPushProduct = map.useCanPushProduct()
    const canSaveMap = map.useCanSaveMap()

    if (! canPushProduct && ! canSaveMap) {
        return null
    }

    const onClick = async () => {
        if (canPushProduct) {
            await map.cmdPushSave()
        }
        else {
            await map.cmdSaveMap()
        }
    }

    return (
        <MenuButton
            onClick={onClick}
            {...props}
        >
            更新制品
        </MenuButton>
    )
}
